<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-15 px-7 type-career-overseas"
  >
    <div class="header">
      <div class="d-flex">
        <h1 class="title">
          {{ $t(template.careerOverseasTitle) }}
          <span v-if="itemMaxLength" class="max-length-guide">
            {{ $t('최대') }} {{ $t(itemMaxLength)
            }}{{ $t(' 개 입력 가능') }}</span
          >
        </h1>
      </div>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideCareerOverseas"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-8" v-if="obj">
          <v-row class="mt-2">
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" class="col-md-6" :class="colclass">
                  <DirectInputSelect
                    v-model="obj.overseasCountry"
                    :useDirect="itemDirectInput('careerOverseasCountry')"
                    :items="itemArray('careerOverseasCountry')"
                    :label="itemLabel('careerOverseasCountry')"
                    v-maxlength="'overseas_country'"
                    outlined
                    dense
                    :readonly="isReadonly"
                    hide-details="auto"
                    :rules="[
                      rules.required('careerOverseasCountry', true),
                      rules.maxlength('careerOverseasCountry'),
                    ]"
                    :class="leftRoundedClass"
                  ></DirectInputSelect>
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('careerOverseasSdate')"
                    useMaxCurrentDate
                    :rules="[rules.required('careerOverseasSdate', true)]"
                    v-model="obj.startDate"
                    :type="sdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('careerOverseasEdate')"
                    :rules="[rules.required('careerOverseasEdate', true)]"
                    :min="obj.startDate"
                    v-model="obj.endDate"
                    :type="sdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
          <v-row :class="rowclass">
            <v-col cols="12" :class="colclass">
              <i-text-field
                :label="itemLabel('careerOverseasDesc')"
                v-model="obj.overseasDesc"
                outlined
                dense
                hide-details="auto"
                :rules="[
                  rules.required('careerOverseasDesc', true),
                  rules.maxlength('careerOverseasDesc'),
                ]"
              ></i-text-field>
            </v-col>
          </v-row>
          <v-row v-if="fileUploadYn === 'Y'" :class="rowclass">
            <v-col cols="12" class="btn-post-wrap">
              <CVFileUpload
                ref="objFile"
                :label="itemLabel('careerOverseasFile')"
                :bucketType="'temp'"
                :rules="[rules.required('careerOverseasFile', true)]"
                :sectionKey="'career_overseas_temp'"
                :existingFileId="obj.overseasFileId"
                :maxSize="itemLength('careerOverseasFile')"
                :isReadonly="isReadonly"
                @upload="uploadFile"
                @delete="deleteFile"
              ></CVFileUpload>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="d-md-none d-block">
              <i-btn elevation="0" color="normal" outlined block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <template v-for="(item, i) in careerOverseas">
          <v-divider :key="'careeroverseasdiv' + i" v-if="i != 0"></v-divider>
          <div class="mt-8" v-if="item" :key="'careeroverseas' + i">
            <v-row class="mt-2">
              <v-col
                cols="12"
                :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
              >
                <v-row>
                  <v-col cols="12" class="col-md-6" :class="colclass">
                    <DirectInputSelect
                      v-maxlength="'overseas_country'"
                      :useDirect="itemDirectInput('careerOverseasCountry')"
                      :items="itemArray('careerOverseasCountry')"
                      v-model="item.overseasCountry"
                      :label="itemLabel('careerOverseasCountry')"
                      outlined
                      :readonly="isReadonly"
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('careerOverseasCountry'),
                        rules.maxlength('careerOverseasCountry'),
                      ]"
                      @change="save(i)"
                      :class="leftRoundedClass"
                    ></DirectInputSelect>
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('careerOverseasSdate')"
                      useMaxCurrentDate
                      :rules="[rules.required('careerOverseasSdate')]"
                      v-model="item.startDate"
                      @change="save(i)"
                      :type="sdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('careerOverseasEdate')"
                      :rules="[rules.required('careerOverseasEdate')]"
                      :min="item.startDate"
                      v-model="item.endDate"
                      @change="save(i)"
                      :type="sdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-text-field
                  :label="itemLabel('careerOverseasDesc')"
                  v-model="item.overseasDesc"
                  outlined
                  dense
                  hide-details="auto"
                  @blur="save(i)"
                  :rules="[
                    rules.required('careerOverseasDesc'),
                    rules.maxlength('careerOverseasDesc'),
                  ]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
            </v-row>
            <v-row v-if="fileUploadYn === 'Y'" :class="rowclass">
              <v-col cols="12" class="btn-post-wrap">
                <CVFileUpload
                  :label="itemLabel('careerOverseasFile')"
                  :sectionKey="'careerOverseas' + item.seq"
                  :rules="[rules.required('careerOverseasFile')]"
                  :existingFileId="item.overseasFileId"
                  :maxSize="itemLength('careerOverseasFile')"
                  :isReadonly="isReadonly"
                  @upload="uploadFile"
                  @delete="deleteFile"
                ></CVFileUpload>
              </v-col>
            </v-row>
            <v-row class="mt-2" v-if="!isReadonly">
              <v-col cols="12" class="d-md-none d-block">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
          </div>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { mdiCalendarBlank } from '@mdi/js';
import CVFileUpload from './CVFileUpload.vue';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  mixins: [LoadingMixin],
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },

    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    CVFileUpload,
    CommonDatePicker,
    DirectInputSelect,
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.careerOverseas?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.careerOverseas?.oMaxLength ||
        this.opts.careerOverseas?.oMaxLength > this.careerOverseas.length
      );
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    itemSeq: 1,
    obj: null,
    careerOverseas: [],
    fileUploadYn: '',
    sdateFormat: '',
    edateFormat: '',
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      if (key === 'careerOverseasFile')
        label += this.$t(' [최대크기 : ') + this.itemLength(key) + 'MB]';

      return label;
    },
    itemLength: function(key) {
      var length = 0;
      if (this.opts && this.opts.hasOwnProperty(key)) {
        var defaultLength =
          key.indexOf('file') >= 0 || key.indexOf('File') >= 0 ? 2 : 0;
        length = this.opts[key].oLength
          ? this.opts[key].oLength
          : defaultLength;
      }
      return length;
    },

    setting: function() {
      switch (this.template.typeCareerOverseas) {
        case 'A':
          this.fileUploadYn = 'N';
          break;
        case 'B':
          this.fileUploadYn = 'Y';
          break;
        default:
          this.fileUploadYn = 'N';
          break;
      }

      if (this.opts) {
        let $this = this;
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'careerOverseasSdate') {
            $this.sdateFormat = prop.oFormat;
          } else if (prop.id.cvColumn === 'careerOverseasEdate') {
            $this.edateFormat = prop.oFormat;
          }
        }
      }
      this.dataSetting();
      this.obj = this.defaultObj();
    },
    dataSetting: function() {
      if (
        this.info &&
        this.info.careerOverseas &&
        this.info.careerOverseas.length > 0
      ) {
        this.itemSeq = this.info.careerOverseas[0].id.seq;
        this.careerOverseas = [];

        let $this = this;
        this.info.careerOverseas.forEach(function(v) {
          var startDate = '';

          var endDate = '';

          if (v.overseasSdate) {
            if ($this.sdateFormat === 'YYYY.MM') {
              startDate =
                v.overseasSdate.substring(0, 4) +
                '-' +
                v.overseasSdate.substring(4, 6);
            } else if ($this.sdateFormat === 'YYYY.MM.DD') {
              startDate =
                v.overseasSdate.substring(0, 4) +
                '-' +
                v.overseasSdate.substring(4, 6) +
                '-' +
                v.overseasSdate.substring(6, 8);
            }
          }

          if (v.overseasEdate) {
            if ($this.edateFormat === 'YYYY.MM') {
              endDate =
                v.overseasEdate.substring(0, 4) +
                '-' +
                v.overseasEdate.substring(4, 6);
            } else if ($this.edateFormat === 'YYYY.MM.DD') {
              endDate =
                v.overseasEdate.substring(0, 4) +
                '-' +
                v.overseasEdate.substring(4, 6) +
                '-' +
                v.overseasEdate.substring(6, 8);
            }
          }

          let obj = {
            seq: v.id.seq,
            overseasCountry: v.overseasCountry,
            overseasSdate: v.overseasSdate,
            overseasEdate: v.overseasEdate,
            overseasDesc: v.overseasDesc,
            overseasFileId: v.overseasFileId ? v.overseasFileId : null,
            start: '',
            end: '',
            startDate: startDate,

            endDate: endDate,
          };

          $this.careerOverseas.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        overseasCountry: '',
        overseasSdate: '',
        overseasEdate: '',
        overseasDesc: '',
        overseasFileId: null,
        start: '',
        end: '',
        startDate: '',
        endDate: '',
      };
      return obj;
    },
    add: function() {
      if (!this.canAdd && this.$i18n.locale == 'ko')
        return this.$showAlert(
          `${this.template.careerOverseasTitle} 은(는) 최대 ${this.opts.careerOverseasTitle.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      else if (!this.canAdd && this.$i18n.locale == 'en')
        return this.$showAlert(
          `MaxSize of ${this.template.careerOverseasTitle} is ${this.opts.careerOverseasTitle.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.careerOverseas &&
        this.opts.careerOverseas.oRequireYn &&
        this.opts.careerOverseas.oRequireYn == 'Y' &&
        this.careerOverseas.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      var item = i === -1 ? this.obj : this.careerOverseas[i];

      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;
      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const p = {
        id: id,
        overseasCountry: item.overseasCountry,
        overseasSdate: item.startDate.replace(pattern, ''),
        overseasEdate: item.endDate.replace(pattern, ''),
        overseasDesc: item.overseasDesc,
        overseasFileId: item.overseasFileId,
      };

      this.$emit('save', p, 'careerOverseas', i);
    },
    savecallback: function(res, i) {
      var item = i === -1 ? this.obj : this.careerOverseas[i];

      if (res.status !== 200) {
        console.log('CAREER_OVERSEAS SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.careerOverseas.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();

        if (item.overseasFileId) {
          this.applyFile(item.overseasFileId);
        }
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.careerOverseas[i].seq,
      };

      this.$emit('delete', p, 'careerOverseas', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('CAREER DELETE FAIL');
      } else {
        snack.danger(`삭제되었습니다.`);
        this.careerOverseas.splice(i, 1);
      }
      this.hideLoading();
    },
    uploadFile(sectionKey, fileId) {
      if (sectionKey.indexOf('temp') > -1) {
        this.obj.overseasFileId = String(fileId);
      } else {
        var seq = sectionKey.substring(
          'careerOverseas'.length,
          sectionKey.length,
        );
        var idx = -1;
        this.careerOverseas.forEach(function(v, i) {
          if (String(v.seq) === seq) {
            v.overseasFileId = fileId;
            idx = i;
          }
        });
        if (idx !== -1) this.save(idx);
      }
    },
    deleteFile(sectionKey) {
      var seq = sectionKey.substring(
        'careerOverseas'.length,
        sectionKey.length,
      );
      var idx = -1;
      this.careerOverseas.forEach(function(v, i) {
        if (String(v.seq) === seq) {
          v.overseasFileId = '';
          idx = i;
        }
      });
      if (idx !== -1) this.save(idx);
    },
    applyFile(fileId) {
      this.$emit('applyFile', 'careerOverseas', fileId);
    },
    applyFilecallback: function(res) {
      if (res.status !== 200) {
        console.log('CAREER_OVERSEAS FILE APPLY FAIL');
      } else {
        this.$refs.objFile.initFiles();
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-career .sub-title-standard {
  position: relative;
}
.type-career .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-career .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
